// Custom UAR HTTP headers
export enum X_UAR_HTTP_HEADERS {
  'X-UAR-Client-Codename' = 'X-UAR-Client-Codename',
  'X-UAR-Session-Duration' = 'X-UAR-Session-Duration',
  'X-UAR-CorrelationId' = 'X-UAR-CorrelationId',
  'X-UAR-EchoTestRunId' = 'X-UAR-EchoTestRunId',
  'X-UAR-RequestId' = 'X-UAR-RequestId',
  'X-UAR-DealId' = 'X-UAR-DealId',
  'X-UAR-RooftopId' = 'X-UAR-RooftopId',
  'X-UAR-UserType' = 'X-UAR-UserType',
}

// Codenames of each client, used for identifying the caller of HTTP requests
export enum CLIENT_CODENAMES {
  COMMAND_CENTER = 'command-center',
  CHAIRMAN = 'chairman',
  INSTORE = 'instore',
  LAUNCHPAD = 'launchpad',
  ONLINE = 'online',
  STANDALONE = 'standalone',
  PAPYRUS = 'papyrus',
  WEB = 'web',
}
